import { useState } from 'react';
import s from './ReviewStar.module.scss';

const StarSVG = ({ filled }) => (
  <svg
    width="40"
    height="41"
    viewBox="0 0 40 41"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M9.7085 37.1667L12.4168 25.4583L3.3335 17.5833L15.3335 16.5417L20.0002 5.5L24.6668 16.5417L36.6668 17.5833L27.5835 25.4583L30.2918 37.1667L20.0002 30.9583L9.7085 37.1667Z"
      fill={filled ? '#FFC107' : '#D9D9D9'}
    />
  </svg>
);

const ReviewStar = ({ score, onChange }) => {
  const [hoveredStar, setHoveredStar] = useState(null);
  const [selectedScore, setSelectedScore] = useState(score);

  const handleMouseEnter = (index) => {
    setHoveredStar(index);
  };

  const handleMouseLeave = () => {
    setHoveredStar(null);
  };

  const handleClick = (index) => {
    const newScore = index + 1;
    setSelectedScore(newScore);
    if (onChange) onChange(newScore);
  };

  return (
    <div className={s.starRating}>
      <input type="hidden" name="rating" value={selectedScore} required />
      {[...Array(5)].map((_, index) => {
        const isFilled = index < (hoveredStar !== null ? hoveredStar + 1 : selectedScore);
        return (
          <div
            key={index}
            className={s.star}
            onMouseEnter={() => handleMouseEnter(index)}
            onMouseLeave={handleMouseLeave}
            onClick={() => handleClick(index)}
          >
            <StarSVG filled={isFilled} />
          </div>
        );
      })}
    </div>
  );
};

export default ReviewStar;
